import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const RadiusIcon = ({
  size = '24px',
  color = COLORS.kinetikBlue,
  sx = {},
  ...props
}) => (
  <SvgIcon sx={{ width: size, height: size, ...sx }} {...props}>
    <path
      fill={color}
      d="M19.5 12a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
      opacity={0.1}
    />
    <path
      fill={color}
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z"
      opacity={0.1}
    />
    <path fill={color} d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </SvgIcon>
);

RadiusIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  sx: PropTypes.object,
};

export default RadiusIcon;
